import { useMemo } from "react";
import { marked } from "marked";

/**
 * Odpowiedzi modelu renderujemy jako markdown, ale surowego HTML-a nie ufamy:
 * najpierw escapujemy `<`, `>` i `&`, dopiero potem parsujemy markdown.
 */
function escapeHtml(text: string): string {
  return text.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}

export function Markdown({ text }: { text: string }) {
  const html = useMemo(
    () => marked.parse(escapeHtml(text), { async: false, breaks: true }) as string,
    [text],
  );
  return <div className="md" dangerouslySetInnerHTML={{ __html: html }} />;
}
